import config from "config"
import httpService from "services/httpService"

const endpoint = `${config.api}/TeamMembers`

export function getTeamMembersList() {
  // const data = await httpService.get(`${endpoint}/TeamMembersList`)
  // return data
  return {
    items: [
      {
        "firstName": "Steven",
        "surname": "Charlton",
        "jobTitle": "Founder & CEO",
        "email": "steven@io-atelier.com",
        "phone": "+44 (0) 7800 582169",
        "phone2": "",
        "bio": "Steven Charlton is a visionary leader passionate about transforming design through innovation and collaboration. As the Founder of I/O Atelier, Steven blends creativity, data science, and technology to challenge conventions and deliver groundbreaking solutions.<br/><br/>With decades of experience in leading global studios across Europe, Africa, and the Middle East, Steven drives the team to explore bold ideas and redefine the future of design.<br/><br/><i>\"At I/O Atelier, we believe in pushing boundaries and unlocking new possibilities where creativity meets data.\"</i>",
        "image": "/assets/team/profileImage/Steven.jpg",
        "displayOrder": 1,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 1
      },
      {
        "firstName": "Mehdi",
        "surname": "Jelokhani",
        "jobTitle": "Co-Founder & Associate Design Director",
        "email": "mehdi@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Mehdi Jelokhani’s design journey spans continents and cultures, bringing a global perspective to every project. From hospitals in the Middle East to innovative co-working spaces in Europe, Mehdi’s expertise lies in crafting environments that resonate with both functionality and human connection.<br/><br/>At I/O Atelier, he merges creativity with data-driven insights to design spaces that are as meaningful as they are impactful.<br/><br/><i>\"Design is more than aesthetics—it’s about shaping experiences that connect people and values.\"</i>",
        "image": "/assets/team/profileImage/Mehdi.jpg",
        "displayOrder": 2,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 2
      },
      {
        "firstName": "Petya",
        "surname": "Maydanova",
        "jobTitle": "Senior Architect & Project Lead",
        "email": "petya@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Petya Maydanova combines a passion for public and leisure spaces with expertise in sustainable architecture and listed buildings. Her diverse portfolio spans cinemas, retail, and residential projects.<br/><br/>At I/O Atelier, she leads projects with a focus on creativity, functionality, and environmental responsibility.<br/><br/><i>\"Architecture is about crafting spaces that connect people and inspire engagement.\"</i>",
        "image": "/assets/team/profileImage/Petya.jpg",
        "displayOrder": 3,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 3
      },
      {
        "firstName": "Kristina",
        "surname": "Milicevic",
        "jobTitle": "Document Control Manager",
        "email": "kristina@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Kristina Milicevic is a seasoned expert in document management, specializing in Aconex systems to ensure seamless project workflows. As Document Control Manager at I/O Atelier, Kristina brings a meticulous approach to managing complex documentation processes, ensuring accuracy and efficiency in every project.<br/><br/>Her expertise supports the team’s mission to blend creativity with precision and data-driven methodologies.<br/><br/><i>\"Efficient document control is the backbone of every successful project, enabling creativity to flourish within structured systems.\"</i>",
        "image": "/assets/team/profileImage/Kristina.jpg",
        "displayOrder": 4,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 4
      },
      {
        "firstName": "Amanda",
        "surname": "Baldwin",
        "jobTitle": "Design Director",
        "email": "amanda@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Amanda Baldwin is a cornerstone of I/O Atelier, leading the design team with over 27 years of experience in creating workplaces, hospitality spaces, and cultural environments.<br/><br/>A super-talented and seasoned expert, Amanda’s passion for design is matched by her dedication to innovation and functionality. She is especially committed to designing spaces that accommodate neurodiverse individuals, ensuring inclusivity and accessibility in every project.<br/><br/><i>\"Design should inspire and engage, leaving a lasting impact on people and the planet.\"</i>",
        "image": "/assets/team/profileImage/Amanda.jpg",
        "displayOrder": 5,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 5
      },
      {
        "firstName": "Ian",
        "surname": "Little",
        "jobTitle": "Director of Design",
        "email": "ian@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "With over 25 years of expertise, Ian Little has shaped environments across workplace, entertainment, and cultural sectors. Ian’s work is grounded in creating human-friendly spaces that balance function and creativity.<br/><br/>At I/O Atelier, he leads design strategies that integrate sustainability and innovation, delivering transformative results.<br/><br/><i>\"Great design is about elevating everyday experiences and inspiring connection.\"</i>",
        "image": "/assets/team/profileImage/Ian.jpg",
        "displayOrder": 6,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 6
      },
      {
        "firstName": "Susanne",
        "surname": "Chan",
        "jobTitle": "BIM Manager & Innovation Lead",
        "email": "susanne@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Susanne specializes in bridging design and technology to create collaborative and efficient workflows. With extensive experience in BIM and digital tools, she ensures that innovation is embedded in every project at I/O Atelier.<br/><br/>Her work fosters seamless integration of people, processes, and policies to deliver exceptional results.<br/><br/><i>\"Innovation thrives where creativity and technology work hand in hand.\"</i>",
        "image": "/assets/team/profileImage/Susanne.jpg",
        "displayOrder": 7,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 7
      },
      {
        "firstName": "Jonathan",
        "surname": "Hill",
        "jobTitle": "Director of Machine Learning",
        "email": "jonathan@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Jonathan Hill is an expert in AI and machine learning, dedicated to integrating advanced technologies into creative processes. With a background as a Principal Data Scientist, Jonathan drives innovation at I/O Atelier by developing AI solutions that empower designers and clients alike.<br/><br/>His work ensures data becomes a seamless partner in delivering cutting-edge design.<br/><br/><i>\"At I/O Atelier, we don’t just use AI—we harness its potential to amplify creativity.\"</i>",
        "image": "/assets/team/profileImage/Jonathan.jpg",
        "displayOrder": 8,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 8
      },
      {
        "firstName": "Alessio",
        "surname": "Petrin",
        "jobTitle": "Head of Product Engineering",
        "email": "alessio@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Alessio Petrin brings deep expertise in scalable architecture and user-centric digital solutions. With experience across industries like PropTech, fintech, and LegalTech, Alessio combines technical mastery with a creative approach to solve complex challenges.<br/><br/>As Head of Product Engineering, he leads the development of transformative technologies that redefine how design meets data.<br/><br/><i>\"I/O Atelier is where innovation and practicality intersect, creating tools that enhance everyday experiences.\"</i>",
        "image": "/assets/team/profileImage/Alessio.jpg",
        "displayOrder": 9,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 9
      },
      {
        "firstName": "Bartosz",
        "surname": "Kurylek",
        "jobTitle": "AI Integration Architect",
        "email": "bartosz@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Bartosz Kurylek merges technical skills with a creative mindset to advance I/O Atelier’s AI-driven initiatives. Specializing in generative design and process automation, Bartosz plays a key role in integrating data and technology into the creative process, helping to redefine the possibilities of design.<br/><br/><i>\"At I/O Atelier, we’re shaping a new era where creativity meets intelligent systems.\"</i>",
        "image": "/assets/team/profileImage/Bartosz.jpg",
        "displayOrder": 10,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 10
      },
      {
        "firstName": "Mrugank",
        "surname": "Modi",
        "jobTitle": "BIM Manager",
        "email": "mrugank@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Mrugank Modi is a forward-thinking BIM Manager who excels at integrating cutting-edge technology with innovative design methodologies. With a strong background in parametric modeling and digital workflows, Mrugank is dedicated to enhancing collaboration and precision across all projects at I/O Atelier.<br/><br/>His expertise lies in leveraging advanced tools and techniques to streamline processes, optimize outcomes, and foster creative excellence.<br/><br/><i>\"BIM is a powerful enabler for creating smarter, more efficient, and future-ready designs.\"</i>",
        "image": "/assets/team/profileImage/Mrugank.jpg",
        "displayOrder": 11,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 11
      },
      {
        "firstName": "Vriti",
        "surname": "Sachdeva",
        "jobTitle": "Project Architect",
        "email": "vriti@io-atelier.com",
        "phone": "",
        "phone2": "",
        "bio": "Vriti Sachdeva brings a creative and meticulous approach to her role as Project Architect at I/O Atelier. With a passion for blending design and data, Vriti excels in delivering projects that are both innovative and functional.<br/><br/>Her commitment to sustainability and collaboration ensures that every project she leads meets the highest standards of quality and impact.<br/><br/><i>\"Architecture is about solving problems with creativity and delivering spaces that inspire.\"</i>",
        "image": "/assets/team/profileImage/Vriti.jpg",
        "displayOrder": 12,
        "isFeatured": true,
        "isAdvisor": false,
        "id": 12
      },
    ],
    responseMessage: null,
    responseType: "SUCCESS",
    id: null,
  }
}

export async function getAdvisorsList() {
  const data = await httpService.get(`${endpoint}/AdvisorsList`)
  return data
}
